import { useSelector } from 'react-redux';

// Filter definitions kept close to the hook to avoid selector files
export const filterOptions = [
  { value: 0, label: 'globals.all', fnc: (item) => item },
  { value: 1, label: 'dashboard.notFinished', fnc: (item) => item.progress < 1 },
  { value: 2, label: 'globals.finished', fnc: (item) => item.progress === 1 },
  { value: 3, label: 'dashboard.ownCourses', fnc: (item) => item.canEdit },
  { value: 4, label: 'dashboard.invitedCourses', fnc: (item) => !item.canEdit },
];

export const studentFilterOptions = [
  { value: 0, label: 'globals.all', fnc: (item) => item },
  { value: 1, label: 'dashboard.notFinished', fnc: (item) => item.progress < 1 },
  { value: 2, label: 'globals.finished', fnc: (item) => item.progress === 1 },
];

export const useDashboardFilters = () => {
  const currentFilter = useSelector((state) => state.dashboardFilters.currentFilter);
  const currentStudentFilter = useSelector((state) => state.dashboardFilters.currentStudentFilter);

  return {
    filterOptions,
    studentFilterOptions,
    currentFilter,
    currentStudentFilter,
  };
};

